import { IGroupedComboBoxGroup } from 'grouped-combobox-core';
import { IStringResources } from '../reka/FontPicker.types.base';

export const createOnAnnounceSearchResult =
    (stringResources: IStringResources) =>
    (results: IGroupedComboBoxGroup[], filterText: string): string => {
        if (results.length === 0) {
            return stringResources.noSuggestionsAnnouncement.replace('{0}', filterText);
        } else {
            const numberSuggestionsPerGroup = results
                .map((group) =>
                    stringResources.numberOfSuggestionsInGroupAnnouncement
                        .replace('{0}', `${group.items.length}`)
                        .replace('{1}', `${group.text}`)
                )
                .join(', , ');

            const numberOfSuggestions = stringResources.numberOfSuggestionsAnnouncement
                .replace('{0}', `${results.reduce((sum, group) => sum + group.items.length, 0)}`)
                .replace('{1}', filterText);

            return `${numberOfSuggestions}. , ${numberSuggestionsPerGroup}`;
        }
    };
